import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { dynamicUnitName } from 'components/units/UnitDefinitionsAndMasks';

const format = ({ value, unit }) => `${String(value)} ${dynamicUnitName(unit) || ''}`.trim();

// Asked when the entered volume exceeds the container's capacity. Cancelling is the
// default (focused, so Enter cancels) and sends the operator back to the volume.
// Forcing is a small button at the bottom left, away from Cancel, so it cannot be
// tapped by mistake; the row then shows in the admin "Points à vérifier" (Items to
// check) table, as the hint under the description says (a tooltip is not seen on touch).
export default function VolumeOverCapacityDialog({ issue, onCancel, onForce }) {
  const { t } = useTranslation();
  if (!issue) return null;
  return (
    <Dialog
      open
      onClose={onCancel}
      disableRestoreFocus
      fullWidth
      maxWidth="xs"
      aria-labelledby="volume-over-capacity-title"
    >
      <DialogTitle id="volume-over-capacity-title">{t('operation.volume_over_capacity.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(`operation.volume_over_capacity.description_${issue.capacityKey}`, {
            volume: format(issue.volume),
            capacity: format(issue.capacity),
          })}
        </DialogContentText>
        <DialogContentText variant="body2" sx={{ mt: 2 }}>
          {t('operation.volume_over_capacity.force_hint')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button size="small" color="inherit" onClick={onForce} sx={{ color: 'text.secondary' }}>
          {t('operation.volume_over_capacity.force')}
        </Button>
        <Button variant="contained" onClick={onCancel} autoFocus>{t('cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
